import { liteClient } from 'algoliasearch/lite'
import { currentUser } from '@lib/utils'

const searchClient = liteClient(import.meta.env.VITE_ALGOLIA_APP_ID, import.meta.env.VITE_ALGOLIA_SEARCH_API_KEY)

const environment = import.meta.env.VITE_APP_ENV

const user = currentUser()

export async function fetchFromAlgolia(
  query,
  {
    indexes = ["Client", "Product", "Act"].map(index => [index, environment].join("_")),
    filters,
    hitsPerPage = 10,
    transform,
    onError
  } = {}
) {
  try {
    const data = await searchClient.search({
      requests: indexes.map(index => ({
        indexName: index,
        query,
        hitsPerPage,
        userToken: user?.id,
        ...(filters ? { filters } : {})   // 👈 Add filters only if present
      }))
    })

    if (!data) return []

    if (transform) return transform(data)

    return data.results.flatMap(result =>
      result.hits.map(hit => ({
        index: result.index,
        ...hit
      }))
    )
  } catch (error) {
    onError ? onError(error) : console.error(error)
    return []
  }
}


export default searchClient
